module.exports = __webpack_public_path__ + "b361618c1efc105cbae835f7f77333d5.png";